import { Col } from 'antd'
import PerFlexRow from '../FlexRow'

import './index.less'

export const MeetingStatusModalDivider = (): JSX.Element => {
  return (
    <>
      <Col span={8} />
      <Col span={8}>
        <PerFlexRow align="middle" justify="center">
          <div className="per-meeting-status-modal-divider"></div>
        </PerFlexRow>
      </Col>
      <Col span={8} />
    </>
  )
}
